import React, { useState } from "react";
import HelpIcon from "@material-ui/icons/Help";
import HelpModal from "./HelpModal";

export const ColumnHeaderWithHelp = ({ title, helpType, helpContent, helpTitle, t }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  if (!helpContent && !helpType) {
    return <span>{title}</span>;
  }

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <span>{title}</span>
        <HelpIcon
          style={{ fontSize: 18, cursor: "pointer", color: "#005a92" }}
          onClick={handleOpenModal}
        />
      </div>
      <HelpModal
        open={openModal}
        onClose={handleCloseModal}
        content={helpContent}
        type={helpType}
        t={t}
      />
    </>
  );
};